var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "draggable__dragbutton text-nowrap" }, [
      _c("span", { staticClass: "draggable__dragbutton-action" }, [
        _c("i", {
          staticClass: "fa fa-ellipsis-v",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-ellipsis-v",
          attrs: { "aria-hidden": "true" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }